import React from 'react'
import { FormContext, useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'

import { TextBox } from 'components'
import { AssociationModal, InformDataModal } from './components'

import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'

import schema from './schema'
import * as service from 'service'
import constants from 'constants/index'

const MessageForm = ({
  ticket,
  ticketId,
  refresh,
  setLoading,
  disabled,
  ...rest
}) => {
  const { MESSAGE_STATUS_BUTTON_ITEMS, AWAITING_REPLY_VALIDATION_STATUS_ID } =
    constants.tickets
  const { RESTRICTED_KIND_ID } = constants.ticketMessages

  const snackbar = useSnackbar()

  const formMethods = useForm({
    validationSchema: schema,
    defaultValues: {
      content: '',
      attachments: [],
      statusId: AWAITING_REPLY_VALIDATION_STATUS_ID || '',
    },
  })

  const { handleSubmit, reset } = formMethods

  const buttonItems = MESSAGE_STATUS_BUTTON_ITEMS.map((item) => ({
    ...item,
    disabled: item.id !== AWAITING_REPLY_VALIDATION_STATUS_ID,
  }))

  const pluralSuffix = ticket?.daysToCompanyDeadlineDate !== 1 ? 's' : ''
  const deadlineMessage =
    ticket?.daysToCompanyDeadlineDate <= 0
      ? 'A resolução dessa solicitação se encontra atrasada!'
      : `${ticket?.daysToCompanyDeadlineDate} dia${pluralSuffix} restante${pluralSuffix}`

  const hasTitularData = ticket?.configuration?.hasTitularData
  const hasAutomaticAnswer = !!ticket?.configuration?.automaticAnswer

  const isTitularDataMissing = hasTitularData == null
  const isDataProvisionMissing = !ticket?.configuration?.dataWasProvided

  const onSubmit = async (data) => {
    try {
      setLoading(true)

      const ticketMessageResponse =
        await service.dponet.titularTickets.createMessage({
          ticketId,
          kind: RESTRICTED_KIND_ID,
          content: data?.content,
          attachments: data?.attachments,
        })

      const ticketMessage = ticketMessageResponse?.data?.ticketMessage

      await service.dponet.titularTickets.update({
        ticketId,
        ticketMessageId: ticketMessage?.id,
        statusId: data?.statusId,
      })

      snackbar.open({
        message: 'Mensagem enviada com sucesso!',
        variant: 'success',
      })
      refresh()
      reset()
    } catch (error) {
      console.error(error)
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Ocorreu um erro tentar enviar a mensagem!',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <FormContext {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)} id="ticket-form">
        <TextBox
          buttonItems={buttonItems}
          subTitle="Exclusivo"
          form="ticket-form"
          deadlineMessage={
            <>
              Prazo:&nbsp;
              <strong>{deadlineMessage}</strong>
            </>
          }
          common
          infoTooltip={
            'As mensagens enviadas neste espaço são privadas e acessíveis ' +
            'apenas por você e pelo Encarregado de Proteção de Dados(DPO) da organização no grupo Advisor. Utilize ' +
            'este canal para tratar assuntos relacionados à sua solicitação com ' +
            'total segurança e privacidade.'
          }
          disabled={disabled}
          {...rest}
        >
          {isTitularDataMissing && !disabled && (
            <Box px={2} pt={2}>
              <AssociationModal
                ticketId={ticketId}
                setLoading={setLoading}
                refresh={refresh}
              />
            </Box>
          )}
          {!isTitularDataMissing &&
            hasTitularData &&
            isDataProvisionMissing &&
            !disabled &&
            !hasAutomaticAnswer && (
              <Box px={2} pt={2}>
                <InformDataModal
                  ticketId={ticketId}
                  setLoading={setLoading}
                  refresh={refresh}
                />
              </Box>
            )}
        </TextBox>
      </form>
    </FormContext>
  )
}

MessageForm.propTypes = {
  ticket: PropTypes.object,
  ticketId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  refresh: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default MessageForm
